module.exports = __webpack_public_path__ + "static/media/Crown_end.2a22cb69.mp4";